import { memoizeFunction } from "@fluentui/react";

import { AppShyComponentStyles } from "@1js/acui-shy-component";

export const getShyRibbonStyles = memoizeFunction(
  (
    componentHeight: number,
    usePopOver: boolean,
    isAnimating: boolean,
    skipAnimation: boolean
  ): AppShyComponentStyles => {
    // in popover, this 2px prevents overflow: hidden from cropping out the drop shadow on the ribbon
    const shiftForShadow = usePopOver ? 2 : 0;

    return {
      container: [
        {
          width: "100%",
          selectors: {
            "& > :first-child": {
              position: "absolute",
              width: "100%",
            },
          },
        },
        skipAnimation && {
          transitionDuration: "0s",
        },
        usePopOver
          ? {
              position: "absolute",
            }
          : {
              position: "relative",
            },
      ],
      expanded: {
        opacity: 1,
        height: componentHeight,
        overflow: isAnimating ? "hidden" : undefined,
        selectors: {
          "& > :first-child": isAnimating
            ? {
                // during animation, positioning relative to bottom achieves slide up look
                bottom: shiftForShadow,
              }
            : {
                // once fully expanded (not animating) positioning relative to top ensures smooth
                // transition between MLR and SLR
                top: 0,
              },
        },
        paddingBottom: isAnimating ? 0 : 2,
      },
      collapsed: {
        height: 0,
        opacity: 1,
        selectors: {
          "& > :first-child": {
            bottom: shiftForShadow,
          },
        },
        paddingBottom: 0,
        overflow: "hidden",
      },
    };
  }
);
